__turbopack_context__.v({
  "Mui-focused": "dOB7tq_Mui-focused",
  "MuiSelect-select": "dOB7tq_MuiSelect-select",
  "countryName": "dOB7tq_countryName",
  "flag": "dOB7tq_flag",
  "flagContainer": "dOB7tq_flagContainer",
  "flagImage": "dOB7tq_flagImage",
  "flagSelect": "dOB7tq_flagSelect",
});
